import React from 'react';
import { supportEmail } from '../data/content';
export function Footer() {
  return <footer className="bg-brand-navyDark px-4 py-4 text-center text-[10px] font-medium leading-snug text-white/60 sm:px-6 sm:text-[11px]" data-id="element-72" data-mp="3gezeh7brdx2q">
      <p className="mb-1" data-id="element-73" data-mp="32p5kybpb6omo">
        📩 Contact :{' '}
        <a href={`mailto:${supportEmail}`} className="font-bold hover:text-brand-green" data-id="element-74" data-mp="36p6cmy1f4wbo">
          {supportEmail}
        </a>
      </p>
      <p className="mb-1 font-extrabold uppercase text-white/80" data-id="element-75" data-mp="3ug3bpa847z5i">
        © 2026 PADEL COACH READY™ — Tous droits réservés.
      </p>
      <p className="mx-auto max-w-xl" data-id="element-76" data-mp="36mtcl0px0t0">
        Les informations présentées dans ce système sont exclusivement destinées à des fins
        pédagogiques et professionnelles. Elles ne remplacent ni votre jugement professionnel, ni
        votre responsabilité en tant que coach ou entraîneur. Adaptez toujours les exercices, les
        séances, les progressions et les planifications au niveau, aux capacités et aux objectifs de
        vos joueurs.
      </p>
    </footer>;
}